var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { remCalc } from '../styled-components';
export var Small = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.25rem 0;\n  font-size: ", ";\n  color: ", ";\n"], ["\n  margin: 0.25rem 0;\n  font-size: ", ";\n  color: ", ";\n"])), remCalc(12), function (p) { return p.theme.colorBodyText; });
var templateObject_1;
